export const categoryOrder = [
    'introduction',
    'setup',
    'core',
    'layout',
    'navigation',
    'forms',
    'utility',
    'hooks'
];

export const docs = [
    {
        id: 'getting-started',
        title: 'Getting Started',
        category: 'introduction',
        desc: 'Installation, quick setup, and basic usage of MouseUI',
        interfaces: [],
        types: [],
        isCustom: true,
        path: '/content/getting-started.md'
    },
    {
        id: 'theming',
        title: 'Theming',
        category: 'introduction',
        desc: 'How to customize colors, support light/dark mode, and override CSS variables',
        interfaces: [],
        types: [],
        isCustom: true,
        path: '/content/theming.md'
    },
    {
        id: 'css',
        title: 'CSS & Styling',
        category: 'introduction',
        desc: 'Using CSS custom properties, SCSS mixins, and advanced styling techniques',
        interfaces: [],
        types: ['SASS', 'SCSS'],
        isCustom: true,
        path: '/content/css.md'
    },
    {
        id: 'mouse-ui-provider',
        title: 'MouseUIProvider',
        category: 'setup',
        desc: 'Required root provider that enables theming and context for all MouseUI components',
        interfaces: [],
        types: [],
        path: '/content/mouse-ui-provider.md'
    },
    {
        id: 'theme-context',
        title: 'ThemeContext',
        category: 'setup',
        desc: 'Context for reading and toggling the current light/dark theme',
        interfaces: [],
        types: [],
        path: '/content/theme-context.md'
    },
    {
        id: 'toast-provider',
        title: 'ToastProvider',
        category: 'setup',
        desc: 'Manages and displays temporary toast notifications with position control',
        interfaces: ['ToastData'],
        types: ['ToastType'],
        path: '/content/toast-provider.md'
    },
    {
        id: 'alert',
        title: 'Alert',
        category: 'core',
        desc: 'Displays contextual feedback messages for success, error, warning, or info states',
        interfaces: [],
        types: ['AlertProps', 'AlertType'],
        path: '/content/alert.md'
    },
    {
        id: 'button',
        title: 'Button',
        category: 'core',
        desc: 'Versatile button component supporting multiple variants and loading states',
        interfaces: [],
        types: ['ButtonProps'],
        path: '/content/button.md'
    },
    {
        id: 'button-group',
        title: 'ButtonGroup',
        category: 'core',
        desc: 'Groups multiple buttons together with horizontal or vertical layout options',
        interfaces: [],
        types: ['ButtonGroupProps'],
        path: '/content/button-group.md'
    },
    {
        id: 'loader',
        title: 'Loader',
        category: 'core',
        desc: 'Loading indicator with radial spinner and horizontal bar variants',
        interfaces: [],
        types: ['LoaderProps'],
        path: '/content/loader.md'
    },
    {
        id: 'tooltip',
        title: 'Tooltip',
        category: 'core',
        desc: 'Displays additional information on hover or focus with smart positioning',
        interfaces: ['TooltipProps'],
        types: ['TooltipPosition'],
        path: '/content/tooltip.md'
    },
    {
        id: 'header',
        title: 'Header',
        category: 'layout',
        desc: 'Responsive header component with sticky support and mobile menu toggle',
        interfaces: [],
        types: ['HeaderProps'],
        path: '/content/header.md'
    },
    {
        id: 'container',
        title: 'Container',
        category: 'layout',
        desc: 'Flexible layout wrapper with responsive options',
        interfaces: [],
        types: ['ContainerProps'],
        path: '/content/container.md'
    },
    {
        id: 'footer',
        title: 'Footer',
        category: 'layout',
        desc: 'Multi-column footer layout with optional inner footer content',
        interfaces: [],
        types: ['FooterProps'],
        path: '/content/footer.md'
    },
    {
        id: 'nav-dropdown',
        title: 'NavDropdown',
        category: 'navigation',
        desc: 'Dropdown menu for navigation items with mobile and desktop support',
        interfaces: [],
        types: ['NavDropdownProps'],
        path: '/content/nav-dropdown.md'
    },
    {
        id: 'nav-list',
        title: 'NavList',
        category: 'navigation',
        desc: 'Container for organizing navigation items with left or right alignment',
        interfaces: [],
        types: ['NavListProps'],
        path: '/content/nav-list.md'
    },
    {
        id: 'nav-item',
        title: 'NavItem',
        category: 'navigation',
        desc: 'Individual navigation link or clickable item',
        interfaces: [],
        types: ['NavItemProps'],
        path: '/content/nav-item.md'
    },
    {
        id: 'form-provider',
        title: 'FormProvider',
        category: 'forms',
        desc: 'Central context provider for form state management and validation',
        interfaces: [],
        types: ['FormProviderProps', 'FormErrors', 'FormTouched', 'FormValues'],
        path: '/content/form-provider.md'
    },
    {
        id: 'form-consumer',
        title: 'FormConsumer',
        category: 'forms',
        desc: 'Render prop component to access form state without hooks',
        interfaces: [],
        types: [],
        path: '/content/form-consumer.md'
    },
    {
        id: 'use-form',
        title: 'useForm',
        category: 'forms',
        desc: 'Hook to access full form state, values, errors, and validation methods',
        interfaces: [],
        types: ['FormContextType'],
        path: '/content/use-form.md'
    },
    {
        id: 'use-form-field',
        title: 'useFormField',
        category: 'forms',
        desc: 'Hook for managing individual form field state and value',
        interfaces: [],
        types: ['FormFieldHookReturn'],
        path: '/content/use-form-field.md'
    },
    {
        id: 'input-group',
        title: 'InputGroup',
        category: 'forms',
        desc: 'Wrapper for grouping form inputs with flexible layout and spacing options',
        interfaces: [],
        types: ['InputGroupProps'],
        path: '/content/input-group.md'
    },
    {
        id: 'input',
        title: 'Input',
        category: 'forms',
        desc: 'Styled text input with validation and error support',
        interfaces: [],
        types: ['InputProps'],
        path: '/content/input.md'
    },
    {
        id: 'text-area',
        title: 'TextArea',
        category: 'forms',
        desc: 'Multi-line text input with validation support',
        interfaces: [],
        types: ['TextAreaProps'],
        path: '/content/text-area.md'
    },
    {
        id: 'checkbox',
        title: 'Checkbox',
        category: 'forms',
        desc: 'Styled checkbox input for single or multiple selections',
        interfaces: [],
        types: ['CheckboxProps'],
        path: '/content/checkbox.md'
    },
    {
        id: 'radio',
        title: 'Radio',
        category: 'forms',
        desc: 'Radio button group for selecting one option from multiple choices',
        interfaces: [],
        types: ['RadioProps'],
        path: '/content/radio.md'
    },
    {
        id: 'select',
        title: 'Select',
        category: 'forms',
        desc: 'Styled dropdown select component with options',
        interfaces: [],
        types: ['SelectProps'],
        path: '/content/select.md'
    },
    {
        id: 'slider',
        title: 'Slider',
        category: 'forms',
        desc: 'Range slider for selecting numeric values within a min/max range',
        interfaces: [],
        types: ['SliderProps'],
        path: '/content/slider.md'
    },
    {
        id: 'date-input',
        title: 'DateInput',
        category: 'forms',
        desc: 'Native date picker input with form integration and validation',
        interfaces: [],
        types: ['DateInputProps'],
        path: '/content/date-input.md'
    },
    {
        id: 'accordion',
        title: 'Accordion',
        category: 'utility',
        desc: 'Collapsible content panels with single or multiple open support',
        interfaces: [],
        types: ['AccordionProps'],
        path: '/content/accordion.md'
    },
    {
        id: 'accordion-item',
        title: 'AccordionItem',
        category: 'utility',
        desc: 'Individual collapsible item used inside Accordion',
        interfaces: [],
        types: ['AccordionItemProps'],
        path: '/content/accordion-item.md'
    },
    {
        id: 'image',
        title: 'Image',
        category: 'utility',
        desc: 'Enhanced image component with lazy loading and styling options',
        interfaces: ['ImageProps'],
        types: [],
        path: '/content/image.md'
    },
    {
        id: 'modal',
        title: 'Modal',
        category: 'utility',
        desc: 'Overlay dialog for focused interactions with multiple sizes',
        interfaces: [],
        types: ['ModalProps'],
        path: '/content/modal.md'
    },
    {
        id: 'use-toast',
        title: 'useToast',
        category: 'utility',
        desc: 'Hook for triggering toast notifications',
        interfaces: [],
        types: ['ToastContextType'],
        path: '/content/use-toast.md'
    }
];